<template>
    <div class="templates_mode_selector" v-bind="getPT('root')" data-pc-section="root">
        <div v-if="$slots.default" class="templates_mode_selector__element">
            <slot></slot>
        </div>
        <template v-else>
            <SelectButton
                :modelValue="mode"
                :options="options"
                :optionLabel="optionLabel"
                :optionValue="optionValue"
                class="templates_mode_selector__component"
                aria-labelledby="basic"
                unstyled
                :allowEmpty="false"
                @change="onChange"
                v-bind="getPT('select_button')"
                data-pc-section="select_button"
            />
        </template>
    </div>
</template>
<script>
/**
 * Единый шаблон для переключения типов, видов, модов.
 * Выбор отображения зависит от наличия слота.
 * В шаблоне HTML для выделения активного пункта добавлять класс a.active
 */
import SelectButton from "primevue/selectbutton";
import PassThrough from "../mixins/PassThrough";

export default {
    name: "TemplatesModeSelector",
    emits: ['update:mode'],
    mixins: [PassThrough],
    props: {
        mode: {
            required: false,
            default: '',
        },
        options: {
            type: Array,
            required: false,
            default: [],
        },
        optionLabel: {
            type: String,
            required: false,
            default: 'label',
        },
        optionValue: {
            type: String,
            required: false,
            default: 'value',
        },
    },
    methods: {
        onChange(e) {
            this.$emit('update:mode', e.value);
        },
    },
    components: {
        SelectButton,
    }
}
</script>

<style scoped>
.templates_mode_selector {
    --container-background-grey: #f1f5f9;
    --container-background: #E7F5D6;
    --button-background-active: #fff;
    --button-text-color: #64748b;
    --button-text-color-active: #73b61d;
    --button-box-shadow-active: 0 1px 2px 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.04);
}
/* стили для HTML */
.templates_mode_selector__element {
    display: flex;
    border-radius: var(--border-radius);
    background-color: var(--container-background);
    gap: 8px;
    padding: 4px;
}
.templates_mode_selector__element :slotted(a) {
    font-weight: 400;
    font-size: 13px;
    display: block;
    text-decoration: none;
    cursor: pointer;
    border-radius: var(--border-radius);
    padding: 5px 16px;
    color: var(--button-text-color);
}
.templates_mode_selector__element :slotted(a).active {
    background-color: var(--button-background-active);
    box-shadow: var(--button-box-shadow-active);
    color: var(--button-text-color-active);
    cursor: default;
}
/* стили для компонента */
.templates_mode_selector__component {
    display: flex;
}
.templates_mode_selector__component > :deep(div) {
    background-color: var(--container-background);
    color: var(--button-text-color);
    padding: 0.5rem 1rem;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
}
.templates_mode_selector__component > :deep(div)::before {
    content: "";
    position: absolute;
    left: 0.25rem;
    top: 0.25rem;
    width: calc(100% - 0.5rem);
    height: calc(100% - 0.5rem);
    border-radius: 4px;
}
.templates_mode_selector__component :deep(span) {
    position: relative;
    font-weight: 400;
    font-size: 13px;
    display: block;
}
.templates_mode_selector__component :deep(span) {
    padding: 1px 4px;
}
.templates_mode_selector__component > :deep(div):last-child {
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
}
.templates_mode_selector__component > :deep(div):first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
}
.templates_mode_selector__component > :deep(div)[data-p-highlight="true"] {
    background-color: var(--container-background);
    color: var(--button-text-color-active);
    cursor: default;
}
.templates_mode_selector__component > :deep(div)[data-p-highlight="true"]::before {
    background-color: var(--button-background-active);
    box-shadow: var(--button-box-shadow-active);
}
</style>
